import { object, string, TypeOf } from 'zod';

/* ---------------------------- CreateSessionBody --------------------------- */

export const CreateSessionBody = object({
    refreshToken: string().optional(),
    purchaseCode: string().optional(),
});
export type CreateSessionBody = TypeOf<typeof CreateSessionBody>;

/* --------------------------------- Session -------------------------------- */

export const Session = object({
    id: string(),
    userId: string().optional(),
    refreshToken: string().optional(),
});
export type Session = TypeOf<typeof Session>;
